import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { FilterModal } from '@/features/w/[identifier]/backoffice/purchase_order_contract_tasks/{components}/FilterModal';
import { KanbanElement } from '@/features/w/[identifier]/backoffice/purchase_order_contract_tasks/{components}/KanbanElement';
import { ListElement } from '@/features/w/[identifier]/backoffice/purchase_order_contract_tasks/{components}/ListElement';
import { SearchConditionTags } from '@/features/w/[identifier]/backoffice/purchase_order_contract_tasks/{components}/SearchConditionTags';
import { useBackofficeSearchCondition } from '@/providers/BackofficeSearchConditionProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useEffect } from 'react';

export const BackofficePurchaseOrderContractTasks = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('契約申請（費用）タスク一覧'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { _w_, me } = useCurrentWorkspace();
  const {
    purchaseOrderContractTaskDisplayType: displayType,
    setPurchaseOrderContractTaskDisplayType: setDisplayType,
    purchaseOrderContractTaskSearchCondition: searchCondition,
    setPurchaseOrderContractTaskSearchCondition: setSearchCondition,
  } = useBackofficeSearchCondition();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <div className="btn-group">
            <button
              className={`btn btn-icon ${displayType == 'list' ? 'btn-dark' : 'btn-outline-dark'}`}
              onClick={() => setDisplayType('list')}
            >
              <i className="fas fa-th-list"></i>リスト
            </button>
            <button
              className={`btn btn-icon ${displayType == 'kanban' ? 'btn-dark' : 'btn-outline-dark'}`}
              onClick={() => setDisplayType('kanban')}
            >
              <i className="fas fa-th-large"></i>ボード
            </button>
          </div>
          <button className="btn btn-icon-only btn-dark mx-2" data-bs-toggle="modal" data-bs-target="#modal-filter">
            <i className="fas fa-filter"></i>
          </button>
        </div>

        <SearchConditionTags />

        <FilterModal />

        {displayType == 'list' && <ListElement />}
        {displayType == 'kanban' && <KanbanElement />}
      </div>
    </WorkspaceLayout>
  );
};
